import { render, staticRenderFns } from "./CasesDetail.vue?vue&type=template&id=04eb00df&scoped=true"
import script from "./CasesDetail.vue?vue&type=script&lang=js"
export * from "./CasesDetail.vue?vue&type=script&lang=js"
import style0 from "./CasesDetail.vue?vue&type=style&index=0&id=04eb00df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb00df",
  null
  
)

export default component.exports